import { Component, Input, OnInit } from "@angular/core";
import { MacAddressService } from "../../../services/mac-address.service";
import { NgFor, NgIf } from '@angular/common';
import { TranslocoDirective } from "@jsverse/transloco";

@Component({
    selector : 'dl-print-mac-address-result',
    templateUrl : './print-mac-address-result.component.html',
    styleUrls : [
        './print-mac-address-result.component.scss'
    ],
    standalone : true,
    imports : [NgIf, NgFor, TranslocoDirective]
})

export class PrintMacAddressResultComponent implements OnInit {

    @Input() tableData? = [];
    constructor(private addressService : MacAddressService) {}

    ngOnInit(): void { }

    prepareErrorMessage(error) {
        return this.addressService.prepareErrorMessage(error);
    }

}
